// 权益类型
export default function equityTypeFilter(val) {
    let str = '';
    switch (val) {
    case 'WXWY':
        str = '维修无忧';
        break;
    case 'TRAVEL_SUBSIDY':
        str = '代步补贴';
        break;
    case 'YCWY':
        str = '安全无忧';
        break;
    case 'CCWY':
        str = '车窗无忧';
        break;
    case 'GCWY':
        str = '剐蹭补贴';
        break;
    case 'QSWY':
        str = '全损无忧';
        break;
    case 'QSWYB':
        str = '全损无忧(B)';
        break;
    case 'QSWYC':
        str = '全损无忧(C)';
        break;
    case 'CXWY':
        str = '出险无忧';
        break;
    case 'ZJWY':
        str = '折价无忧';
        break;
    case 'SXX':
        str = '随心修';
        break;
    case 'SXX_2':
        str = '随心修2.0';
        break;
    case 'SXX_3':
        str = '随心修3.0';
        break;
    case 'LSCX':
        str = '绿色出行';
        break;
    case 'BJWY':
        str = '保价保障';
        break;
    case 'JKRYW':
        str = '借款人意外';
        break;
    case 'CLFW':
        str = '凯励程车联网服务';
        break;
    case 'YCWYB':
        str = '安全无忧(轮胎、驾意)';
        break;
    case 'JCYW':
        str = '驾乘意外';
        break;
    case 'LTWY':
        str = '轮胎补贴';
        break;
    default:
        break;
    }
    return str;
}
